import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  MYBIOGRAPHIES: {
    path: `${baseRoutes.userBaseRoutes}mybiographies`,
  },
};

export default accessRoute;
